import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import RecruitGlanceLogo from "../components/RecruitGlanceLogo";

export default function GoodbyePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#03140f] px-6 text-slate-950">
      <div className="w-full max-w-lg rounded-lg border border-white/10 bg-white p-6 text-center shadow-2xl shadow-black/30 sm:p-8">
        <div className="mb-6 flex justify-center">
          <RecruitGlanceLogo />
        </div>

        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-lg bg-rose-50 text-rose-700">
          <ShieldOff size={24} />
        </div>

        <h1 className="mt-5 text-3xl font-semibold tracking-tight text-slate-950">
          Account deleted
        </h1>
        <p className="mt-3 text-sm leading-6 text-slate-600">
          Your account, subscription access, and workspace data have been removed permanently.
        </p>
        <p className="mt-4 text-xs font-semibold uppercase tracking-wide text-slate-400">
          Redirecting to the homepage
        </p>
      </div>
    </div>
  );
}
